<template>
  <div v-if="jsonData" class="hstrf-editor">
    <slot />
    <Component
      :is="getComponentOrNodeName(item.type)"
      v-for="(item, index) in jsonData.content"
      :key="`${item.type}_${index}`"
      v-bind="getProps(item)"
    ></Component>
  </div>
</template>

<script setup>
import AdditionalBlock from '@/components/Editor/AdditionalBlock/AdditionalBlock.vue';
import BulletList from '@/components/Editor/BulletList/BulletList.vue';
import ContentVideo from '@/components/Editor/ContentVideo/ContentVideo.vue';
import HeadingBlock from '@/components/Editor/HeadingBlock/HeadingBlock.vue';
import ImageSlider from '@/components/Editor/ImageSlider/ImageSlider.vue';
import ImportantBlock from '@/components/Editor/ImportantBlock/ImportantBlock.vue';
import InfoIcon from '@/components/Editor/InfoIcon/InfoIcon.vue';
import OrderedList from '@/components/Editor/OrderedList/OrderedList.vue';
import ParagraphBlock from '@/components/Editor/ParagraphBlock/ParagraphBlock.vue';
import PromoBlock from '@/components/Editor/PromoBlock/PromoBlock.vue';
import QuoteBlock from '@/components/Editor/QuoteBlock/QuoteBlock.vue';

const props = defineProps({
  jsonStr: {
    type: String,
    required: true,
  },
});

const jsonData = ref(null);

watch(
  () => props.jsonStr,
  () => {
    jsonData.value = JSON.parse(props.jsonStr);
  },
  {
    immediate: true,
  },
);

const getComponentOrNodeName = (type) => {
  const componentMap = {
    'image-slider': ImageSlider,
    'quote-block': QuoteBlock,
    'video-block': ContentVideo,
    'promo-block': PromoBlock,
    paragraph: ParagraphBlock,
    heading: HeadingBlock,
    'info-icon': InfoIcon,
    'important-block': ImportantBlock,
    'additional-block': AdditionalBlock,
    orderedList: OrderedList,
    bulletList: BulletList,
  };

  return componentMap[type] ?? type;
};

const getProps = (item) => {
  switch (item.type) {
    case 'image-slider':
      return {
        images: JSON.parse(item.attrs.slides),
      };
    case 'quote-block':
      return {
        text: item.attrs.text,
        author: item.attrs.author,
        source: item.attrs.source,
      };
    case 'img':
      return {
        imageSrc: item.attrs.src,
        position: item.attrs['data-position'],
        description: item.attrs['data-description'],
        source: item.attrs['data-source'],
        width: item.attrs['data-width'],
      };
    case 'video-block':
      return {
        src: item.attrs.src,
        description: item.attrs['data-description'],
      };
    case 'promo-block':
      return {
        title: item.attrs.title,
        href: item.attrs.href,
        description: item.attrs.description,
      };
    case 'paragraph':
      return {
        content: item.content,
        attrs: item.attrs,
      };
    case 'heading':
      return {
        content: item.content,
        attrs: item.attrs,
      };
    case 'info-icon':
      return {
        text: item.attrs.text,
      };
    case 'important-block':
      return {
        text: item.attrs.text,
        textAlign: item.attrs['text-align'],
      };
    case 'additional-block':
      return {
        text: item.attrs.text,
        textAlign: item.attrs['text-align'],
      };
    case 'orderedList':
      return {
        content: item.content,
        attrs: item.attrs,
      };
    case 'bulletList':
      return {
        content: item.content,
        attrs: item.attrs,
      };
    default:
      return {};
  }
};
</script>

<style scoped lang="scss"></style>
